import { render } from "./IncodeCopyLink.vue.js?vue&type=template&id=3dd9f138!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IncodeCopyLink.vue?vue&type=template&id=3dd9f138"
import script from "./IncodeCopyLink.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IncodeCopyLink.vue?vue&type=script&setup=true&lang=js"
export * from "./IncodeCopyLink.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IncodeCopyLink.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/merchant3/components/steps/kyc/IncodeCopyLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3dd9f138"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3dd9f138', __exports__)) {
    api.reload('3dd9f138', __exports__)
  }
  
  module.hot.accept("./IncodeCopyLink.vue.js?vue&type=template&id=3dd9f138!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IncodeCopyLink.vue?vue&type=template&id=3dd9f138", () => {
    api.rerender('3dd9f138', render)
  })

}


export default __exports__